import { useApp } from '../context/AppContext';
import { useI18n } from '../context/I18nContext';

export default function HelpModal() {
  const { setShowHelp } = useApp();
  const { t } = useI18n();

  const coreFeatures = [
    { key: 'multiAgent', icon: '🤖' },
    { key: 'debateRounds', icon: '🔄' },
    { key: 'synthesis', icon: '📚' },
    { key: 'intervention', icon: '✋' }
  ];

  const extraFeatures = [
    { key: 'voice', icon: '🎙️' },
    { key: 'agentsPersonas', icon: '🎭' },
    { key: 'export', icon: '📄' },
    { key: 'history', icon: '🕘' },
    { key: 'collaboration', icon: '👥' },
    { key: 'accessibility', icon: '♿' }
  ];

  return (
    <div className="modal-overlay show" onClick={e => e.target === e.currentTarget && setShowHelp(false)}>
      <div className="modal help-modal">
        <div className="modal-header">
          <h2>{t('howItWorksTitle')}</h2>
          <button className="modal-close" onClick={() => setShowHelp(false)}>&times;</button>
        </div>
        <div className="modal-body help-modal-body">
          <section className="help-section">
            <p className="help-intro">{t('helpIntro')}</p>
          </section>

          <section className="help-section">
            <h3>{t('helpCoreTitle')}</h3>
            <div className="help-steps">
              {[
                { num: '1', title: t('helpStep1Title'), desc: t('helpStep1Text') },
                { num: '2', title: t('helpStep2Title'), desc: t('helpStep2Text') },
                { num: '3', title: t('helpStep3Title'), desc: t('helpStep3Text') },
                { num: '4', title: t('helpStep4Title'), desc: t('helpStep4Text') },
                { num: '5', title: t('helpStep5Title'), desc: t('helpStep5Text') },
                { num: '6', title: t('helpStep6Title'), desc: t('helpStep6Text') },
                { num: '7', title: t('helpStep7Title'), desc: t('helpStep7Text') },
                { num: '8', title: t('helpStep8Title'), desc: t('helpStep8Text') },
                { num: '9', title: t('helpStep9Title'), desc: t('helpStep9Text') }
              ].map(step => (
                <div key={step.num} className="how-step">
                  <div className="how-number">{step.num}</div>
                  <div>
                    <h4>{step.title}</h4>
                    <p>{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="help-section">
            <h3>{t('helpDebateMechanismTitle')}</h3>
            <p className="help-intro">{t('helpDebateMechanismText')}</p>
          </section>

          <section className="help-section">
            <h3>{t('helpFeaturesTitle')}</h3>
            <div className="help-grid">
              {coreFeatures.map(f => (
                <div key={f.key} className="help-card">
                  <span className="help-card-icon">{f.icon}</span>
                  <h4>{t(`help${f.key.charAt(0).toUpperCase() + f.key.slice(1)}Title`)}</h4>
                  <p>{t(`help${f.key.charAt(0).toUpperCase() + f.key.slice(1)}Text`)}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="help-section">
            <h3>{t('helpMoreTitle')}</h3>
            <div className="help-grid">
              {extraFeatures.map(f => (
                <div key={f.key} className="help-card">
                  <span className="help-card-icon">{f.icon}</span>
                  <h4>{t(`help${f.key.charAt(0).toUpperCase() + f.key.slice(1)}Title`)}</h4>
                  <p>{t(`help${f.key.charAt(0).toUpperCase() + f.key.slice(1)}Text`)}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="help-section">
            <h3>{t('helpCommandsTitle')}</h3>
            <ul className="help-list">
              <li><code>/image</code> — {t('helpCommandImage')}</li>
              <li><code>/mindmap</code> — {t('helpCommandMindMap')}</li>
              <li><code>/intervene</code> — {t('helpCommandIntervene')}</li>
              <li><code>/voice</code> — {t('helpCommandVoice')}</li>
              <li><code>/export pdf</code> / <code>docx</code> / <code>pptx</code> — {t('helpCommandExport')}</li>
            </ul>
          </section>

          <section className="help-section">
            <h3>{t('helpAddedValueTitle')}</h3>
            <p className="help-intro">{t('helpAddedValueText')}</p>
          </section>

          <section className="help-section">
            <h3>{t('helpPlansTitle')}</h3>
            <p>{t('helpPlansText')}</p>
          </section>

          <section className="help-section">
            <h3>{t('helpPrivacyTitle')}</h3>
            <p>{t('helpPrivacyText')}</p>
          </section>

          <section className="help-section help-tip">
            <strong>{t('helpTipTitle')}</strong>
            <p>{t('helpTipText')}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
